export default __webpack_public_path__ + "static/media/screen4.813b0b4a.png";